import React from 'react';
import './WorkoutProposalBubble.css';

function WorkoutProposalBubble({ annotation, onApprove, disabled = false }) {
  if (!annotation?.proposalId) return null;
  const change = annotation.type === 'replacement'
    ? `Coach suggests ${annotation.exerciseName} → ${annotation.replacementName || 'a replacement exercise'}`
    : annotation.type === 'removal'
      ? `Coach suggests removing ${annotation.exerciseName}`
      : `Coach suggests ${annotation.currentPrescription || 'the current prescription'} → ${annotation.proposedPrescription || 'an updated prescription'}`;

  return (
    <section
      className="workout-proposal-bubble"
      aria-label={`Coach suggestion for ${annotation.exerciseName || 'exercise'}`}
      onPointerDown={event => event.stopPropagation()}
      onClick={event => event.stopPropagation()}
    >
      <div className="workout-proposal-bubble__heading"><span aria-hidden="true">✦</span><strong>{change}</strong></div>
      {annotation.reason && <p>{annotation.reason}</p>}
      {annotation.appliesToFutureWorkouts && <div className="workout-proposal-bubble__future">Applies to future workouts; your active sets stay untouched.</div>}
      <div className="workout-proposal-bubble__scope">
        {annotation.scope === 'dojo' && !annotation.canApprove
          ? 'Dojo chief approval required'
          : `Approves all ${annotation.affectedCount || 1} annotated change${annotation.affectedCount === 1 ? '' : 's'}`}
      </div>
      {annotation.canApprove && (
        <button type="button" disabled={disabled} onClick={() => onApprove?.(annotation.proposalId)}>
          {disabled ? 'Applying…' : 'Approve workout changes'}
        </button>
      )}
    </section>
  );
}

export default WorkoutProposalBubble;
